

import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/b5bfa44d5950b8773965295c375e5018/4a873f19408a96004d6b4501fc573522.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="container mx-auto px-4 w-full">
        <div className="max-w-2xl text-white">
          <div className="mb-6">
            <div className="flex flex-col gap-3 mb-4 items-start">
            <div className="relative bg-gradient-to-r from-yellow-400/20 to-orange-400/20 border-2 border-yellow-400 text-white px-8 py-4 rounded-xl shadow-xl backdrop-blur-sm flex items-center transform hover:scale-105 transition-transform duration-300">
              <div className="absolute -top-2 -right-2 bg-gradient-to-r from-red-400 to-pink-500 text-white px-2 py-1 rounded-full text-xs font-bold shadow-lg animate-pulse">✨</div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
                  <i className="ri-gift-line text-white text-sm"></i>
                </div>
                <span className="text-lg font-bold tracking-wide">入会金無料</span>
              </div>
            </div>
            
            <div className="relative bg-gradient-to-r from-green-400/20 to-teal-500/20 border-2 border-green-400 text-white px-8 py-4 rounded-xl shadow-xl backdrop-blur-sm flex items-center transform hover:scale-105 transition-transform duration-300">
              <div className="flex items-center gap-3">
                <div className="relative">
                  <div className="w-6 h-6 bg-gradient-to-br from-green-400 to-teal-500 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
                    <span className="text-white font-bold text-sm">初</span>
                  </div>
                  <div className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full flex items-center justify-center border border-white shadow-md">
                    <span className="text-xs">🔰</span>
                  </div>
                </div>
                <div>
                  <span className="text-lg font-bold tracking-wide">初心者大歓迎</span>
                </div>
              </div>
            </div>
          </div>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            理想の<span className="text-teal-400">カラダ</span>に。
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            お子様からご高齢の方まで<br />
            一人ひとりに合わせたパーソナルケアをおすすめします！
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button size="lg" onClick={() => window.open('https://reserva.be/hk0923', '_blank')}>
              予約ページ
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => {
                const element = document.getElementById('services');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white/10 border-white text-white hover:bg-white hover:text-gray-900"
            >
              サービス詳細
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
